<template>
	<div>
		<h2 style="margin-bottom: 30px;">扫码领券详情</h2>
		<el-form label-width="100px" label-position="left">
			<el-form-item label="名称">
				<el-input v-model="sendData.name" style="width: 300px;"></el-input>
			</el-form-item>
			<el-form-item label="跳转页背景">
				<div>
					<upload v-model="sendData.image"  class="el-tabs-pane-upload"  ref="sss"
						style="width: 300px;height: auto;" />
					<!-- <p style="font-size: 14px;color: #808080;">点击上传详情页图片</p> -->
				</div>
			</el-form-item>
			<el-form-item label="二维码">
				<div>
					<upload v-model="sendData.qrCode"  class="el-tabs-pane-upload"  ref="sss"
						style="width: 150px;height: 150px;" />
					<!-- <p style="font-size: 14px;color: #808080;">点击上传详情页图片</p> -->
				</div>
			</el-form-item>
			<!-- 			<el-form-item label="跳转链接">
				<el-input v-model="sendData.url" style="width: 300px;"></el-input>
			</el-form-item> -->
			<el-form-item label="选择券或券包">
				<el-radio-group v-model="sendData.coupon">
					<el-radio label="0">券</el-radio>
					<el-radio label="1">券包</el-radio>
				</el-radio-group>
			</el-form-item>
			<el-form-item v-if="sendData.coupon == 0" label="添加券">
				<el-button type="text" @click="dialog_quan=true" style="color:#999; border:2px dashed; width:100px;">
					<i class="el-icon-plus"></i>选择券
				</el-button>
			</el-form-item>
			<el-form-item v-if="sendData.coupon == 1" label="添加券包">
				<el-button type="text" @click="dialog_package=true" style="color:#999; border:2px dashed; width:100px;">
					<i class="el-icon-plus"></i>选择券包
				</el-button>
			</el-form-item>
			<el-form-item>
				<router-link to="/scan">
					<el-button>取消</el-button>
				</router-link>
				<el-button @click="save()" type="primary" style="margin-left: 20px;">保存</el-button>
			</el-form-item>
		</el-form>
		<el-dialog :visible.sync="dialog_quan" width="60%">
			<div class="title" style="margin-top:-10px;">
				<div class="blue"></div>
				<div style="flex: 1; font-size: 18px;">选择优惠券</div>
				<!-- <span style="float: right; margin-bottom: 10px;">
					<el-button @click="dialog_quan = false">取 消</el-button>
					<el-button type="primary" @click="dialog_quan = false">确 定</el-button>
				</span> -->
			</div>
			<div>
				<el-table :cell-style="{'text-align':'center'}"
					:header-cell-style="{background:'#F2F2F4','text-align':'center'}" ref="multipleTable"
					:data="couponList" tooltip-effect="dark" style="width: 100%">
					<el-table-column label="券ID">
						<template scope="scope">
							<el-radio :label="scope.row.id" v-model="sendData.couponId"></el-radio>
						</template>
					</el-table-column>
					<el-table-column align="center" prop="title" label="名称"></el-table-column>
					<el-table-column prop="couponType" label="类型"></el-table-column>
					<el-table-column prop="storeNames" label="适用范围"></el-table-column>
					<el-table-column prop="termOfValidity" label="有效期"></el-table-column>
					<el-table-column prop="getNumScaleTotalNum" label="已领取/优惠券总量"></el-table-column>
					<el-table-column prop="useNum" label="已使用"></el-table-column>
				</el-table>
				<div class="pagescg">
					<el-pagination @size-change="handleSizeChange01" @current-change="handleCurrentChange01"
						:current-page="filter1.page" :page-sizes="[10, 20, 30, 50]" :page-size="10"
						layout="total, sizes, prev, pager, next, jumper" :total="filter1.total">
					</el-pagination>
				</div>
				<div class="add_botom">
					<div class="add_botom_nei">
						<el-button size="small" @click="dialog_quan=false">取消</el-button>
						<el-button size="small" type="primary" @click="handleClick()">确定</el-button>
					</div>
				</div>
			</div>
		</el-dialog>
		<el-dialog :visible.sync="dialog_package" width="60%">
			<div class="title" style="margin-top:-10px;">
				<div class="blue"></div>
				<div style="flex: 1; font-size: 18px;">选择券包</div>
				<span style="float: right; margin-bottom: 10px;">
					<el-button @click="dialog_package = false">取 消</el-button>
					<el-button type="primary" @click="dialog_package = false">确 定</el-button>
				</span>
			</div>
			<div>
				<el-table :cell-style="{'text-align':'center'}"
					:header-cell-style="{background:'#F2F2F4','text-align':'center'}" ref="multipleTable"
					:data="couponPackageList" tooltip-effect="dark" style="width: 100%">
					<el-table-column label="券包ID">
						<template scope="scope">
							<el-radio :label="scope.row.id" v-model="sendData.couponId"></el-radio>
						</template>
					</el-table-column>
					<el-table-column prop="name" align="center" label="名称"></el-table-column>
					<!-- <el-table-column prop="coupons" label="优惠券"></el-table-column> -->
					<!-- <el-table-column prop="storeNames" label="适用范围"></el-table-column> -->
					<el-table-column prop="termOfValidity" label="有效期"></el-table-column>
					<!-- 					<el-table-column prop="getNumScaleTotalNum" label="已领取/优惠券总量"></el-table-column>
					<el-table-column prop="useNum" label="已使用"></el-table-column> -->
				</el-table>
				<div class="pagescg">
					<el-pagination @size-change="handleSizeChange02" @current-change="handleCurrentChange02"
						:current-page="filter2.page" :page-sizes="[10, 20, 30, 50]" :page-size="10"
						layout="total, sizes, prev, pager, next, jumper" :total="filter2.total">
					</el-pagination>
				</div>
			</div>
		</el-dialog>
	</div>
</template>
<script>
	import upload from "../../compents/upload/upload";
	export default {
		components: {
			upload
		},
		data() {
			return {
				filter1: {
					pageNum: 1,
					pageSize: 10,
					total: 100
				},
				filter2: {
					pageNum: 1,
					pageSize: 10,
					total: 100
				},
				dialog_quan: false,
				dialog_package: false,
				couponList: '',
				couponPackageList: '',
				sendData: {
					name: '',
					coupon: '',
					couponId: '',
					image: '',
					url: '',
					qrCode: ''
				}
			}
		},
		mounted() {
			this.getCoupon();
			this.getCouponPackage();
			console.log(this.$route.query.id)
			if (this.$route.query.id != null) {
				this.getList();
			}
		},
		methods: {
			getList() {
				this.$http.get("marketing/listScan" + "?id=" + this.$route.query.id).then(res => {
					var a = res.body.data;
					this.sendData.name = a.name;
					this.sendData.coupon = a.coupon.toString();
					this.sendData.couponId = a.couponId;
					this.sendData.image = a.image;
					this.sendData.qrCode = a.qrCode;
					this.sendData.url = a.url;
				})
			},
			getCoupon() {
				this.$http.get("dCoupon/list" + "?pageNum=" + this.filter1.pageNum + "&pageSize=" + this.filter1.pageSize)
					.then(res => {
						this.couponList = res.body.data;
						this.filter1.total = res.body.total;
					})
			},
			getCouponPackage() {
				this.$http.post("couponPackage/findDCouponPackage", JSON.stringify(this.filter2)).then(res => {
					this.couponPackageList = res.body.data;
					this.filter2.total = res.body.total;
				})
			},
			save() {
				var id;
				if (this.$route.query.id != null) {
					id = this.$route.query.id
				}
				let a = {
					id: id,
					name: this.sendData.name,
					image: this.sendData.image,
					coupon: this.sendData.coupon.toString(),
					couponId: this.sendData.couponId,
					url: this.sendData.url,
					qrCode: this.sendData.qrCode

				}
				this.$http.post("marketing/saveScan", JSON.stringify(a)).then(res => {
					if (res.body.code == 200) {
						this.$message.success("保存成功");
						this.$router.push("/scan");
					} else {
						this.$message.error(res.body.msg);
					}
				})
			},
			handleClick() {
				this.updatevolum();
				console.log(this.$route.query.id)
				if (this.$route.query.id != null) {
					this.addvolum(0)
					this.reload();
					this.updatevolum();
					this.pop1 = false
					this.pop2 = false
				} else {
					this.addCoupons = false
					this.pop1 = false
					this.pop2 = false
				}
			},
			handleSizeChange01(val) {
				this.filter1.pageSize = val;
				this.getCoupon();
			},
			handleCurrentChange01(val) {
				this.filter1.pageNum = val;
				this.getCoupon();
			},
			handleSizeChange02(val) {
				this.filter2.pageSize = val;
				this.getCouponPackage();
			},
			handleCurrentChange02(val) {
				this.filter2.pageNum = val;
				this.getCouponPackage();
			}
		}
	};
</script>

<style>
</style>